import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from "../main_website/Navbar";
import Footer from "../main_website/Footer";
import Whatsapp from './Whatsapp';

export default function NotFound() {
    return (
        <div>
            <Navbar />
            <div style={styles.container}>
                <motion.div
                    style={styles.card}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6 }}
                >
                    <h1 style={styles.title}>404 - Page Not Found</h1>
                    <p style={styles.message}>
                        Oops! The page you're looking for doesn't exist in our layout.
                    </p>
                    <Link to="/" style={styles.button}>🏡 View Available Properties</Link>
                </motion.div>

                <style>
                    {`
          @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@500;700&display=swap');
        `}
                </style>
            </div>
            <Whatsapp />
            <Footer />
        </div>
    );
}

const styles = {
    container: {
        background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
        color: '#fff',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: "'Orbitron', sans-serif",
        padding: '20px',
        textAlign: 'center',
    },
    card: {
        background: '#ffffff10',
        backdropFilter: 'blur(10px)',
        border: '1px solid #ffffff22',
        padding: '40px',
        borderRadius: '20px',
        boxShadow: '0 0 40px rgba(0, 0, 0, 0.3)',
        maxWidth: '500px',
        width: '100%',
    },
    title: {
        fontSize: '2.8rem',
        marginBottom: '20px',
        color: '#00ffff',
        textShadow: '0 0 10px #00ffff88',
    },
    message: {
        fontSize: '1.2rem',
        marginBottom: '30px',
        color: '#ddd',
    },
    button: {
        display: 'inline-block',
        backgroundColor: '#00ffff',
        color: '#1a1a1a',
        padding: '14px 30px',
        borderRadius: '50px',
        textDecoration: 'none',
        fontWeight: '700',
        boxShadow: '0 0 15px #00ffff88',
        transition: 'all 0.3s ease',
    },
};